'use client'
import styles from "./HorizontalRow.module.css"
import GameCard, { CardType } from "@/components/UI/GameCard/GameCard";
import { useEffect, useLayoutEffect, useState } from "react";
import IconButton, { IconButtonKind } from "@/components/UI/Buttons/IconButton/IconButton";
import ArrowRight from "@/assets/img/Icon_ChevronRight.svg"
import ArrowLeft from "@/assets/img/Icon_ChevronLeft.svg"
import { useSwipeable } from "react-swipeable";
import { Row, RowStyle } from "@/interfaces/rows_types";
import ViewMore from "../ViewMore/ViewMore";
import { pushToDataLayer } from "@/utils/helpers";

export default function HorizontalRow({ row, analyticsPosition, sideGradients = true }: { row: Row, analyticsPosition?: number, sideGradients?: boolean}) {
  const [columns, setColumns] = useState(6)
  const [transform, setTransform] = useState(0)
  const [index, setIndex] = useState(0)
	const rowLength = (row.show_more !== -1 && row.show_more < row.content.length) ? row.show_more + 1 : row.content.length

  function handleResize() {
		const newColumns = getColumns(window.innerWidth)

		setTransform(prev => (columns / newColumns) * prev)
		setColumns(newColumns)
  }

  useEffect(() => {
		window.addEventListener("resize", handleResize)
		return () => window.removeEventListener("resize", handleResize)
  }, [handleResize])

	useLayoutEffect(() => {
		handleResize()
	}, [])

	function getColumns(width: number): number {
		if (width >= 1920) return 7
		else if (width >= 1440) return 6
		else if (width >= 1050) return 5
		else if (width >= 900) return 4
		else if (width > 600) return 3
		return 2
	}

	const next = () => {
		if(transform < (((rowLength / columns) - 1) * 100) ) {
			setIndex((prev) => prev + 1);
			setTransform(prev => Math.min((((rowLength / columns) - 1) * 100), prev + 100))
			pushToDataLayer({
				event: 'row_scroll',
				scroll_direction: 'forward',
				row: row.id,
				row_position: analyticsPosition
			})
		}
	};

	const prev = () => {
		if(transform > 0) {
			setIndex((prev) => prev - 1);
			setTransform(prev => Math.max(0, prev - 100))
			pushToDataLayer({
				event: 'row_scroll',
				scroll_direction: 'backward',
				row: row.id,
				row_position: analyticsPosition
			})
		}
	};

	const handlers = useSwipeable({
		onSwipedLeft: next,
		onSwipedRight: prev
	})

	return (
		<div>
			<h3 className={`title3 ${styles.title}`}>{row.title}</h3>
			<div className={styles.sliderWrapper} {...handlers}>
				<div className={styles.slider} style={{ transform: `translateX(${-transform}%)` }}>
				{row.content.map((game, idx) => {
					if (row.show_more !== undefined && row.show_more !== -1 && idx >= row.show_more) return null
					const cardType = row.style === RowStyle.HorizontalCards ? CardType.Horizontal : CardType.Vertical
					return (
						<GameCard analyticsIndex={idx} analyticsModule="row" analyticsModuleRow={analyticsPosition} analyticsRow={row.id} analyticsRowName={row.title} game={game} key={game.game_id} type={cardType} columns={columns}/>
					)
				})}
				{row.show_more !== -1 && row.show_more < row.content.length &&
					<ViewMore row={row} columns={columns}/> 
				}
				</div>
				{transform > 0 && <IconButton title={'Arrow left'} className={`${styles.arrow} ${styles.left}`} icon={ArrowLeft} kind={IconButtonKind.FILLED} onClick={prev}/>}
				{transform < (((rowLength / columns) - 1) * 100) && <IconButton title={'Arrow right'} className={`${styles.arrow} ${styles.right}`} icon={ArrowRight} kind={IconButtonKind.FILLED} onClick={next}/>}
				{sideGradients && <div className={styles.leftGradient}></div>}
				{sideGradients && <div className={styles.rightGradient}></div>}
			</div>
		</div>
	)
}